// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1jkRQ","footer":"ModalFilter_footer__2Hiii"};